module.exports = __webpack_public_path__ + "static/img/news1.f9dab35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news2/news1.jpg
// module id = h0Lq
// module chunks = 1